import {
  addMediaToAssetFolder,
  createAssetFolders,
  deleteAssetFolder,
  editAssetFolder,
  fetchAssetFolderById,
  fetchAssetFolders,
  removeMediaFromAssetFolder,
} from './asyncThunks';

export const fetchAssetFoldersBuilder = builder => {
  builder.addCase(fetchAssetFolders.pending, state => {
    state.fetchAssetFoldersInfo.pending = true;
  });
  builder.addCase(fetchAssetFolders.fulfilled, (state, { payload }) => {
    const { folders } = payload;
    state.fetchAssetFoldersInfo.data = folders;
    state.fetchAssetFoldersInfo.pending = false;
  });
  builder.addCase(fetchAssetFolders.rejected, state => {
    state.fetchAssetFoldersInfo.pending = false;
  });
};

export const createAssetFoldersBuilder = builder => {
  builder.addCase(createAssetFolders.pending, state => {
    state.pending.createAssetFolders = true;
  });
  builder.addCase(createAssetFolders.fulfilled, (state, { payload }) => {
    const { folder } = payload;
    state.fetchAssetFoldersInfo.data.push(folder);
    state.pending.createAssetFolders = false;
  });
  builder.addCase(createAssetFolders.rejected, state => {
    state.pending.createAssetFolders = false;
  });
};

export const fetchAssetFolderByIdBuilder = builder => {
  builder.addCase(fetchAssetFolderById.pending, state => {
    state.pending.fetchAssetFolderById = true;
  });
  builder.addCase(fetchAssetFolderById.fulfilled, state => {
    state.pending.fetchAssetFolderById = false;
  });
  builder.addCase(fetchAssetFolderById.rejected, state => {
    state.pending.fetchAssetFolderById = false;
  });
};

export const deleteAssetFolderBuilder = builder => {
  builder.addCase(deleteAssetFolder.pending, state => {
    state.pending.deleteAssetFolder = true;
  });
  builder.addCase(deleteAssetFolder.fulfilled, (state, { payload }) => {
    const { assetFolderId } = payload;
    state.fetchAssetFoldersInfo.data = state.fetchAssetFoldersInfo.data.filter(f => f.id !== assetFolderId);
    state.pending.deleteAssetFolder = false;
  });
  builder.addCase(deleteAssetFolder.rejected, state => {
    state.pending.deleteAssetFolder = false;
  });
};

export const editAssetFolderBuilder = builder => {
  builder.addCase(editAssetFolder.pending, state => {
    state.pending.editAssetFolder = true;
  });
  builder.addCase(editAssetFolder.fulfilled, (state, { payload }) => {
    const { assetFolderId, name } = payload;
    state.fetchAssetFoldersInfo.data = state.fetchAssetFoldersInfo.data.map(f => {
      if (f.id !== assetFolderId) {
        return f;
      } else {
        return { ...f, name };
      }
    });
    state.pending.editAssetFolder = false;
  });
  builder.addCase(editAssetFolder.rejected, state => {
    state.pending.editAssetFolder = false;
  });
};

export const addMediaToAssetFolderBuilder = builder => {
  builder.addCase(addMediaToAssetFolder.pending, state => {
    state.pending.addMediaToAssetFolder = true;
  });
  builder.addCase(addMediaToAssetFolder.fulfilled, (state, { payload }) => {
    const { assetFolderId, numOfPhotos, numOfVideos } = payload;
    state.fetchAssetFoldersInfo.data = state.fetchAssetFoldersInfo.data.map(f => {
      if (f.id !== assetFolderId) {
        return f;
      } else {
        return { ...f, numOfPhotos, numOfVideos };
      }
    });
    state.pending.addMediaToAssetFolder = false;
  });
  builder.addCase(addMediaToAssetFolder.rejected, state => {
    state.pending.addMediaToAssetFolder = false;
  });
};

export const removeMediaFromAssetFolderBuilder = builder => {
  builder.addCase(removeMediaFromAssetFolder.pending, state => {
    state.pending.removeMediaFromAssetFolder = true;
  });
  builder.addCase(removeMediaFromAssetFolder.fulfilled, (state, { payload }) => {
    const { assetFolderId, numOfPhotos, numOfVideos } = payload;
    state.fetchAssetFoldersInfo.data = state.fetchAssetFoldersInfo.data.map(f => {
      if (f.id !== assetFolderId) {
        return f;
      } else {
        return { ...f, numOfPhotos, numOfVideos };
      }
    });
    state.pending.removeMediaFromAssetFolder = false;
  });
  builder.addCase(removeMediaFromAssetFolder.rejected, state => {
    state.pending.removeMediaFromAssetFolder = false;
  });
};
